/* eslint-disable no-restricted-syntax */
import Decimal from 'decimal.js';
import { Holding } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Holding';
import { ContractId } from '@daml/types';
import TemplateContract from './TemplateContract';

type Arg = { requiredAmount: string; holdings: TemplateContract<Holding>[] };

export const getMinAmountCids = (arg: Arg) => {
  const { requiredAmount, holdings } = arg;
  const requiredDecimalAmount = new Decimal(requiredAmount);
  const unlockedHoldings = holdings.filter((h) => !h.payload.lock);

  let aggregated = new Decimal(0);
  const cids: ContractId<Holding>[] = [];

  const unlockedHoldingsSorted = unlockedHoldings.sort((a, b) => {
    const amountA = new Decimal(a.payload.amount);
    const amountB = new Decimal(b.payload.amount);
    return amountA.minus(amountB).toNumber();
  });

  for (const h of unlockedHoldingsSorted) {
    if (aggregated.greaterThanOrEqualTo(requiredDecimalAmount)) {
      break;
    }

    const currHoldingAmount = new Decimal(h.payload.amount);
    aggregated = aggregated.plus(currHoldingAmount);
    cids.push(h.contractId);
  }

  if (aggregated.lessThan(requiredDecimalAmount)) {
    console.error('Error: Not enough holdings to meet the required amount.');
    return [];
  }

  return cids;
};
